// ✅ Main Category Data
export const mainCategoryData = {
  "C3.3": [
    { name: "Corner 3.3", price: 4.5 },
    { name: "Corner Protector 3.3 - Tongue & Groove", price: 3 },
    { name: "Hinge Small", price: 4 },
    { name: "Hinge Medium", price: 8 },
    { name: "Latch 3.3", price: 8 },
    { name: "Latch Numeric", price: 65 },
    { name: "Rivet", price: 0.4 },
    { name: "Aluminium Profile Round Angle 3.3", price: 60.0 },
    { name: "Aluminium Profile Tongue & Groove 3.3", price: 60.0 },
    { name: "MDF 3.3", price: 270 },
    { name: "Eva Sheets", price: 19500 },
    { name: "Surface Handle - small", price: 34 },
    { name: "Surface Handle - medium", price: 37 },
    { name: "Plastic Handle", price: 14 },
    { name: "Medium Duty Handle - bolt", price: 40 },
    { name: "Medium Duty Handle - rivet", price: 40 },
    { name: "Heavy Duty Handle", price: 125 },
    { name: "Rubber Feet", price: 1 },
    { name: "Plastic Feet", price: 1 },
    { name: "Labour Charges", price: 400 },
  ],

  "C5.5": [
    { name: "Corner 5.5", price: 8 },
    { name: "Corner Protector 5.5 - Tongue & Groove", price: 4 },
    { name: "Hinge Medium", price: 8 },
    { name: "Latch 5.5", price: 20 },
    { name: "Latch Key", price: 50 },
    { name: "Rivet", price: 0.4 },
    { name: "Aluminium Profile Square Angle 5.5", price: 60.0 },
    { name: "Aluminium Profile Tongue & Groove 5.5", price: 60.0 },
    { name: "MDF 5.5", price: 305 },
    { name: "Eva Sheets", price: 19500 },
    { name: "Surface Handle - small", price: 70 },
    { name: "Surface Handle - medium", price: 34 },
    { name: "Plastic Handle", price: 60 },
    { name: "Medium Duty Handle - bolt", price: 80 },
    { name: "Medium Duty Handle - rivet", price: 85 },
    { name: "Heavy Duty Handle", price: 100 },
    { name: "Rubber Feet", price: 1 },
    { name: "Plastic Feet", price: 1 },
    { name: "Labour Charges", price: 600 },
  ],
};

// ✅ Dropdown options
export const hingeOptions = ["Hinge Small", "Hinge Medium"];

export const handleOptions = [
  "Surface Handle - small",
  "Surface Handle - medium",
  "Plastic Handle",
  "Medium Duty Handle - bolt",
  "Medium Duty Handle - rivet",
  "Heavy Duty Handle",
];

export const latchOptions = {
  "C3.3": ["Latch 3.3", "Latch Numeric"],
  "C5.5": ["Latch 5.5", "Latch Key"],
};

export const caseColorOptions = ["Silver", "Black"];
